module.exports = __webpack_public_path__ + "static/img/mNew1@2x.3ec4d556.png";